import { render } from "./DashboardTable.vue?vue&type=template&id=6c8c563c&ts=true"
import script from "./DashboardTable.vue?vue&type=script&lang=ts"
export * from "./DashboardTable.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__